import {http} from "@/api/http";

export const SUBSCRIPTION_API_URL = process.env.VUE_APP_SUBSCRIPTION_API_URL

export async function getCompanySubscription(company_id) {
    return await http.get(
        `${SUBSCRIPTION_API_URL}/v1/company-subscriptions/company/${company_id}/full-info-owner`
    )
}

/**
 * Получить список активных тарифов (публичный эндпойнт, не требует аутентификации)
 * @returns {Promise}
 */
export async function getActiveSubscriptions() {
    return await http.get(
        `${SUBSCRIPTION_API_URL}/v1/user-manage/subscriptions`,
        {skipAuth: true}
    )
}

/**
 * Активировать пробный период подписки
 * @param {string} company_id - ID компании
 * @param {string} subscription_id - ID тарифа
 * @returns {Promise}
 */
export async function activateTrial(company_id, subscription_id) {
    return await http.post(
        `${SUBSCRIPTION_API_URL}/v1/user-manage/activate-trial/${company_id}`,
        { subscription_id }
    )
}
